var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

//
// An almost complete implementation in JS of the `java.util.Random`
// class from J2SE, designed to so far as possible produce the same
// output sequences as the Java original when supplied with the same
// seed.
//
var p2_16 = 0x0000000010000;
var p2_24 = 0x0000001000000;
var p2_27 = 0x0000008000000;
var p2_31 = 0x0000080000000;
var p2_32 = 0x0000100000000;
var p2_48 = 0x1000000000000;
var p2_53 = Math.pow(2, 53); // NB: exceeds Number.MAX_SAFE_INTEGER

var m2_16 = 0xffff; //
// multiplicative term for the PRNG
//

var c2 = 0x0005,
    c1 = 0xdeec,
    c0 = 0xe66d;
module.exports = /*#__PURE__*/_createClass(function JavaRandom(seedval) {
  "use strict";

  var _marked = /*#__PURE__*/_regeneratorRuntime().mark(ints),
      _marked2 = /*#__PURE__*/_regeneratorRuntime().mark(longs),
      _marked3 = /*#__PURE__*/_regeneratorRuntime().mark(doubles);

  _classCallCheck(this, JavaRandom);

  var s2, s1, s0;
  var nextNextGaussian;
  var haveNextNextGaussian = false; //
  // 53-bit safe version of
  // seed = (seed * 0x5DEECE66DL + 0xBL) & ((1L << 48) - 1)
  //

  var _next = function _next() {
    var carry = 0xb;
    var r0 = s0 * c0 + carry;
    carry = r0 >>> 16;
    r0 &= m2_16;
    var r1 = s1 * c0 + s0 * c1 + carry;
    carry = r1 >>> 16;
    r1 &= m2_16;
    var r2 = s2 * c0 + s1 * c1 + s0 * c2 + carry;
    r2 &= m2_16;
    s2 = r2;
    s1 = r1;
    s0 = r0;
    return s2 * p2_16 + s1;
  };

  var next_signed = function next_signed(bits) {
    return _next() >> 32 - bits;
  };

  var next = function next(bits) {
    return _next() >>> 32 - bits;
  };

  var checkIsNumber = function checkIsNumber(n) {
    if (typeof n !== 'number') {
      throw TypeError();
    }
  };

  var checkIsPositiveInt = function checkIsPositiveInt(n) {
    var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0x7fffffff;
    checkIsNumber(n);

    if (n < 0 || n > r) {
      throw RangeError();
    }
  }; //
  // 53-bit safe version of
  // seed = (seed ^ 0x5DEECE66DL) & ((1L << 48) - 1)
  //


  function setSeed(n) {
    checkIsNumber(n);
    s0 = n & m2_16 ^ c0;
    s1 = n / p2_16 & m2_16 ^ c1;
    s2 = n / p2_32 & m2_16 ^ c2;
  }

  function nextInt(bound) {
    if (bound === undefined) {
      return next_signed(32);
    }

    checkIsPositiveInt(bound); // special case if bound is a power of two

    if ((bound & -bound) === bound) {
      var r = next(31) / p2_31;
      return ~~(bound * r);
    }

    var bits, val;

    do {
      bits = next(31);
      val = bits % bound;
    } while (bits - val + (bound - 1) < 0);

    return val;
  }

  function nextLong() {
    if (typeof BigInt !== 'function') {
      throw Error('BigInt unsupported');
    }

    var msb = BigInt(next_signed(32));
    var lsb = BigInt(next_signed(32));
    var p2_32n = BigInt(p2_32);
    return msb * p2_32n + lsb;
  }

  function nextBoolean() {
    return next(1) != 0;
  }

  function nextFloat() {
    return next(24) / p2_24;
  }

  function nextDouble() {
    return (p2_27 * next(26) + next(27)) / p2_53;
  }

  function nextGaussian() {
    if (haveNextNextGaussian) {
      haveNextNextGaussian = false;
      return nextNextGaussian;
    } else {
      var v1, v2, s;

      do {
        v1 = 2 * nextDouble() - 1.0;
        v2 = 2 * nextDouble() - 1.0;
        s = v1 * v1 + v2 * v2;
      } while (s >= 1 || s === 0);

      var multiplier = Math.sqrt(-2 * Math.log(s) / s);
      nextNextGaussian = v2 * multiplier;
      haveNextNextGaussian = true;
      return v1 * multiplier;
    }
  } //
  // stream functions replaced with JS generators
  //


  function checkStreamSize(streamSize) {
    if (streamSize === undefined) {
      return undefined;
    }

    checkIsPositiveInt(streamSize, Number.MAX_SAFE_INTEGER);
    return streamSize;
  }

  function ints(streamSize) {
    var forever;
    return _regeneratorRuntime().wrap(function ints$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            streamSize = checkStreamSize(streamSize);
            forever = streamSize === undefined;

          case 2:
            if (!(forever || streamSize-- > 0)) {
              _context.next = 7;
              break;
            }

            _context.next = 5;
            return nextInt();

          case 5:
            _context.next = 2;
            break;

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _marked);
  }

  function longs(streamSize) {
    var forever;
    return _regeneratorRuntime().wrap(function longs$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            streamSize = checkStreamSize(streamSize);
            forever = streamSize === undefined;

          case 2:
            if (!(forever || streamSize-- > 0)) {
              _context2.next = 7;
              break;
            }

            _context2.next = 5;
            return nextLong();

          case 5:
            _context2.next = 2;
            break;

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _marked2);
  }

  function doubles(streamSize) {
    var forever;
    return _regeneratorRuntime().wrap(function doubles$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            streamSize = checkStreamSize(streamSize);
            forever = streamSize === undefined;

          case 2:
            if (!(forever || streamSize-- > 0)) {
              _context3.next = 7;
              break;
            }

            _context3.next = 5;
            return nextDouble();

          case 5:
            _context3.next = 2;
            break;

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _marked3);
  } // list of functions to export, using ES6 scoped-variable keys


  var functions = {
    setSeed: setSeed,
    nextInt: nextInt,
    nextBoolean: nextBoolean,
    nextFloat: nextFloat,
    nextDouble: nextDouble,
    nextGaussian: nextGaussian,
    ints: ints,
    doubles: doubles
  }; // add BigInt support if available

  if (typeof BigInt === 'function') {
    Object.assign(functions, {
      nextLong: nextLong,
      longs: longs
    });
  } // convert into Property Descriptors


  for (var f in functions) {
    functions[f] = {
      value: functions[f]
    };
  } // add them to the current object


  Object.defineProperties(this, functions); // perform seed initialisation

  if (seedval === undefined) {
    seedval = Math.floor(Math.random() * p2_48);
  }

  setSeed(seedval);
});